import api from 'api/apiClient';
import { formatDate, formatDateTime } from 'modules/shared/utils';
import { normalizeStatus } from '../shared/utils';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export const getAllApplicants = async () => {
  const { data: raw } = await unwrap(await api.get('/api/hr/job-applicants'));

  const normalized = raw
    .filter((a) => a.application_status !== 'hired')
    .map((a) => {
      const { bucket, workflow } = normalizeStatus(a.application_status);

      return {
        id: a.id,
        name: a.candidate_name,
        contact: a.contact,
        email: a.email,
        applicationDate: formatDate(a.application_date),
        department: a.department,
        designation: a.designation,
        nextInterview: formatDateTime(a.next_interview),
        currentInterviewRound: a.current_interview_round,
        bucketStatus: bucket,
        workflowStatus: workflow,
        rejectedDate: a.rejected_date ? formatDate(a.rejected_date) : null,
      };
    });

  return {
    applied: normalized.filter((a) => a.bucketStatus === 'applied'),
    scheduled: normalized.filter((a) => a.bucketStatus === 'scheduled'),
    rejected: normalized.filter((a) => a.bucketStatus === 'rejected'),
  };
};

export const scheduleInterview = async (id, data) => {
  if (!id || !data) throw new Error('Candidate id and schedule is required');
  const payload = { action: 'approve', next_interview: data.interviewAt };
  await unwrap(await api.put(`/api/hr/job-applicant/${id}/update-status`, payload));
};
